import { Theme, styled } from "@mui/material";

export const boxContenStyle = (theme: Theme) => ({
  display: "grid",
  gridTemplateColumns: "576px auto",
  // width: "100%",
  width: "100vw",
  height: "100%",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
  [theme.breakpoints.down(800)]: {
    "display": "flex",
    "flexDirection": "column",
    "width": "100%",
    ".logo": {
      "position": "absolute",
      "top": 0,
      "left": 0,
      "background": "#FFFFFF",
      "width": "100%",
      "img": {
        margin: "16px 24px",
        width: "117px",
      },
    },
  },
});

export const boxContenLeftStyle = (theme: Theme) => ({
  "padding": "80px 80px 30px",
  "overflow": "auto",
  "scrollBehavior": "smooth",
  "&::-webkit-scrollbar": {
    width: 0,
  },
  "input:-webkit-autofill": {
    boxShadow: "0 0 0 30px white inset ",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "1.65rem",
  },
  [theme.breakpoints.down(800)]: {
    "padding": 0,
    "paddingBottom": "1rem",
    "margin": "6rem auto 0",
    "width": "90%",
    ".bottom-button": {
      width: "100%",
    },
  },
});

export const locationCardsStyle = (theme : Theme) => ({
  "> label": {
    "padding": 0,
    "borderRadius": "1rem",
    "overflow": "hidden",
    ".MuiRadio-root": {
      display: "none",
    },
    "> span": {
      "width": "100%",
      ".image-container": {
        "height": "10.125rem",
        "width": "100%",
        "position": "relative",
        "> p": {
          "opacity": 0,
          "position": "absolute",
          "top": "50%",
          "left": "50%",
          "transform": "translate(-50%,-50%)",
          "zIndex": 1,
          "width": "100%",
          "height": "100%",
          "display": "grid",
          "placeItems": "center",
          "color": "#FFF",
          "fontSize": "18px",
          "fontWeight": "500",
          "background": "linear-gradient(0deg, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32))",
          "transition": ".3s all",
        },
        "img": {
          height: "100%",
          width: "100%",
          objectFit: "cover",
          position: "relative",
        },
      },
      ".location-option": {
      },
      ".info": {
        "padding": "1.25rem",
        "display": "flex",
        "flexDirection": "column",
        "gap": "0.5rem",
        "*": {
          fontFamily: "geograph-regular",
        },
        "h1": {
          fontFamily: "grenette-light-pro",
          fontWeight: "600",
          fontSize: "20px",
        },
      },
    },
  },
  "> label:hover": {
    ".image-container": {
      "> p": {
        opacity: 1,
      },
    },
  },
  [theme.breakpoints.down(800)]: {
    "display": "flex",
    "flexWrap": "wrap",
    "flexDirection": "row",
    "alignItems": "flex-start",
    "justifyContent": "space-between",
    "gap": "0",
    "> label": {
      "maxWidth": "49%",
      "height": "fit-content",
    },
  },
  [theme.breakpoints.down(600)]: {
    "> label": {
      "maxWidth": "100%",

    },

  },
});

export const boxContenRightStyle = (theme: Theme) => ({
  "> div": {
    height: "100%",
  },
  [theme.breakpoints.down(800)]: {
    display: "none",
  },
});

export const Image = styled("img")(({ theme }) => ({
  objectFit: "cover",
  height: "100vh",
  marginBottom: "-4px",
  width: "100%",
}));
